export default "__VITE_PUBLIC_ASSET__741ca22e__"